'use client'

import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip'
import { motion, AnimatePresence } from 'motion/react'
import { X } from 'lucide-react'

export function ModeBadge({
    label,
    description,
    isActive,
    showClearOnActive,
    onClick,
    onClear,
    className
}: {
    label: string
    description?: string
    isActive?: boolean
    showClearOnActive?: boolean
    onClick?: () => void
    onClear?: () => void
    className?: string
}) {
    return (
        <TooltipProvider>
            <Tooltip delayDuration={300}>
                <TooltipTrigger asChild>
                    <div className={`pt-2 pr-1.5 overflow-visible ${className || ''}`}>
                    <div className="relative inline-flex items-center align-top">
                            <Badge
                                variant={isActive ? 'default' : 'secondary'}
                                className={`cursor-pointer whitespace-nowrap font-medium ${!isActive ? 'hover:bg-primary/30' : ''}`}
                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                    if (isActive && showClearOnActive) {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        onClear?.()
                                        return
                                    }
                                    onClick?.()
                                }}
                            >
                                {label}
                            </Badge>
                            <AnimatePresence>
                                {isActive && showClearOnActive && (
                                    <motion.button
                                        key={`clear-${label}`}
                                        type="button"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.9 }}
                                        whileHover={{ scale: 1.15 }}
                                        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            onClear?.()
                                        }}
                                        className="absolute -top-1 -right-1 z-10 h-3.5 w-3.5 rounded-full bg-muted hover:bg-muted flex items-center justify-center"                                    
                                    >
                                        <X className="h-2.5 w-2.5" />
                                    </motion.button>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                </TooltipTrigger>
                {description && (
                    <TooltipContent side="top" align="center" className="bg-transparent border border-border shadow-none">
                        {description}
                    </TooltipContent>
                )}
            </Tooltip>
        </TooltipProvider>
    )
}


